<template>
  <div class="block-chain-off-chain-channel-list">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :operate-col="operateCol"
        :show-edit="true"
        :paging="paging"
        @pagination="handleSizeOrPageChange"
      >
      </normal-table>
    </common-bg-plate>
    <create-channel ref="createChannel" @updateChan:list="getList()"></create-channel>
    <transaction-dialog ref="transactionDialog" @updateChan:list="getList()"></transaction-dialog>
    <join-channel ref="joinChannel" @updateChan:list="getList()"></join-channel>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import createChannel from './createChannel' //创建
import transactionDialog from './transactionDialog' //交易
import joinChannel from './joinChannel' //加入

export default {
  name: 'Channel',
  components: {
    createChannel,
    transactionDialog,
    joinChannel
  },
  data() {
    return {
      inputContent: '',
      btnList: [
        {
          btnContent: '添加扩容通道',
          click: () => {
            return this.createChannel()
          },
          icon: 'icon-add'
        },
        {
          btnContent: '加入扩容通道',
          click: () => {
            return this.joinChannel()
          },
          icon: 'icon-import'
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'id',
          label: '扩容通道ID',
          minWidth: 269 
        },
        { 
          prop: 'chanName', 
          label: '扩容通道名称',
          minWidth: 269 
        },
        {
          prop: 'balance',
          label: '余额',
          minWidth: 269
        },
        // {
        //   prop: 'status', label: '状态',
        //   formatter: row => {
        //     return this.subscribeStatus(row.status)
        //   }
        // },

        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 269
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '交易',
          click: (row, col, cellValue) => {
            return this.handleTransactions(row)
          },
          icon: 'icon-transcation',
          isText: true
        }
      ],
      operateCol: {
        minWidth: 123
      }
    }
  },
  computed: {
    ...mapState({
      list: state => state.expansionDemo.chan_list,
      paging: state => state.expansionDemo.chan_paging
    })
  },
  mounted() {
    console.log(this.$route.query)
    this.getList()
  },
  methods: {
    ...mapActions(['getOffchainChanLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        offChainId: JSON.parse(this.$route.query.detail).id,
        chainId: this.$route.query.chainId
      }
      this.getOffchainChanLists(params)
    },
    subscribeStatus(status) {
      let statusArr = ['异常', '正藏']
      return statusArr[status]
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleSearch(val) {
      this.inputContent = val
      this.getList()
    },
    refresh() {
      this.inputContent = ''
      this.$refs.singleInput.clear()
      this.getList()
    },
    handleTransactions(row) {
      this.$refs.transactionDialog.handleOpen(row)
    },
    createChannel(row) {
      this.$refs.createChannel.handleOpen(row)
    },
    joinChannel(row) {
      this.$refs.joinChannel.handleOpen(row)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-off-chain-channel-list',
  (
    --block-chain-off-chain-channel-list-list-operate-color: #45c2ff,
    --block-chain-off-chain-channel-list-list-operate-danger-color: #e95757
  ),
  (
    --block-chain-off-chain-channel-list-list-operate-color: #45c2ff,
    --block-chain-off-chain-channel-list-list-operate-danger-color: #e95757
  )
);
.block-chain-off-chain-channel-list {
  @include adaptation(
    (
      --block-chain-off-chain-channel-list-unavaliable-height: 48px
    )
  );
  --block-chain-off-chain-channel-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) -
      var(--block-chain-off-chain-channel-list-unavaliable-height)
  );
  .btn-list-style {
    width: 100%;
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-off-chain-channel-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-off-chain-channel-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-off-chain-channel-list-min-height);

        .operate-item {
          color: var(--block-chain-off-chain-channel-list-list-operate-color);

          &.operate-danger {
            color: var(--block-chain-off-chain-channel-list-list-operate-danger-color);
          }
        }
      }
    }
  }
}
</style>
